import { App } from 'vue';
import VueSkeletonLoader from './components/VueSkeletonLoader.vue';

const Vue3SkeletonLoader = {
  install(app: App) {
    app.component('VueSkeletonLoader', VueSkeletonLoader);
  },
};

export { VueSkeletonLoader };

export default Vue3SkeletonLoader;
